import { useUniversalModalDispatch } from '@components/context/UniversalModalContext';
import { useCallback } from 'react';

export function useDispatchError() {
    const { dispatchNotification } = useUniversalModalDispatch();

    const messageHandler = useCallback(
        (message?: string, type: 'danger' | 'success' = 'danger') => {
            dispatchNotification({
                title: message ?? 'Something went wrong',
                text: '',
                type,
            });
        },
        [dispatchNotification],
    );
    return messageHandler;
}
